<script type="text/javascript">
	import { createEventDispatcher } from "svelte"
	import "./TextfieldWithButton.scss";

	import Textfield, {Input, Textarea} from "@smui/textfield";

	const dispatch = createEventDispatcher(); // keyup | change | buttonclick

	export let value = "";
	export let disabled = false;
	export let buttonIcon = "colorize";
	export let label = "Lng, lat";
</script>

<div class="tfwb-container">
	<div class="tfwb-textfield-container">
		<Textfield dense label={label} variant="filled" value={value} disabled={disabled} on:keyup on:change />
	</div>
	<div class='tfwb-button-container'>
		<button on:click|preventDefault={(e)=>{ dispatch("buttonclick", e); }} class='bg-secondary' disabled={disabled}><span class='material-icons'>{buttonIcon}</span></button>
	</div>
</div>
